import React from 'react'
import "./Explore_game.css"
import Explore_game_banner from './explore_game_banner/Explore_game_banner'
import Explore_game_tab_section from './explore_game_tab_section/Explore_game_tab_section'
import Contribution from '../home/contribution/Contribution'

function Explore_game() {
    return (
        <>
            <section className='Explore_game'>
                <Explore_game_banner />
                <Explore_game_tab_section />
                <Contribution />
            </section>
        </>
    )
}

export default Explore_game